export enum ECountsItem {
  TOTAL,
  ON_TIME,
  DELAYED,
  EARLY,
  IN_JEOPARDY,
  CONTAINERS_IN_ALARMS,
  TOTAL_IN_ALARMS
}

export const eCountsItemMap: Map<ECountsItem, string> = new Map<ECountsItem, string>([
  [ECountsItem.TOTAL, "Total"],
  [ECountsItem.ON_TIME, "On-Time"],
  [ECountsItem.DELAYED, "Delayed"],
  [ECountsItem.EARLY, "Early"],
  [ECountsItem.IN_JEOPARDY, "In Jeopardy"],
  [ECountsItem.CONTAINERS_IN_ALARMS, "Container(s) in alarm"],
  [ECountsItem.TOTAL_IN_ALARMS, "Alarm(s) in total"],
]);
